import React, { useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"

import {
  Box,
  Card,
  CardContent,
  Divider,
  Grid,
  Link,
  Skeleton,
  Slide,
  Typography,
} from "@mui/material"

import {
  MenuBook as Book,
  Close as CloseIcon,
  Map as MapIcon,
} from "@mui/icons-material"

import * as styles from "./Card.module.scss"
import ImagePreview from "../ImagePreview/ImagePreview"

import useImageData from "../../hooks/useImageData"


const DEFAULT_STRING = "N/A"

const CardComponent = ({ enabled, container, data, setData }) => {
  const imageData = useImageData()

  if (data === undefined) {
    data = null;
  }

  function fieldData(field) {
    return data === null ? <Skeleton /> : (data[field] || DEFAULT_STRING)
  }

  function getImageData(id) {
    if (id === null || id === "") return null

    return imageData[id]
  }

  // ImagePreview states
  const [open, setOpen] = React.useState(false);
  const [previewImage, setPreviewImage] = useState();
  const handleOpen = (img) => {
    setPreviewImage(img);
    setOpen(true);
  }
  const handleClose = () => setOpen(false);

  return (
    <Slide
      direction="right"
      in={enabled}
      container={container}
    >
      <Card
        sx={{
          minWidth: [125, 200, 275, 350],
          maxWidth: [180, 280, 375, 475],
        }}
        className={data ? styles.infoCardActive : styles.infoCard}
      >

        <CardContent>
          <CloseIcon style={{ cursor: "pointer" }} onClick={() => setData(null)} />

          <Box sx={{ py: 1, px: 1.5 }}>

            <Grid container alignItems="start" columnSpacing={2} mb={2}>
              <Grid item xs={4}>
                {data === null
                  ? <Skeleton />
                  : <GatsbyImage
                    onClick={() => handleOpen(getImageData(data.id))}
                    image={getImageData(data.id)}
                    alt={`Image of ${data.english_name_I}`} />
                }
              </Grid>

              <Grid item xs={8}>
                <Typography color="text.secondary" variant="subtitle2">
                  {fieldData("english_name_I")}
                </Typography>

                <Typography variant="subtitle1">
                  {fieldData("chinese_name_I")}
                </Typography>

                <Typography variant="body2">
                  {"Established in " + fieldData("established_year")}
                </Typography>

                <Typography variant="body2">
                  {"Date of sketch: " + fieldData("date_sketch_created")}
                </Typography>

                <Typography variant="body2">
                  {"Copyright owner: Dr Ho Chee Lick"}
                </Typography>
              </Grid>
            </Grid>

            <Divider />

            <Grid container alignItems="start" rowSpacing={2} my={2}>
              <Grid item xs={2}>
                <MapIcon color="primary" />
              </Grid>
              <Grid item xs={10}>
                <Typography variant="body2">
                  {fieldData("full_address")}
                </Typography>
              </Grid>
            </Grid>

            {data && data.pubs.length > 0 &&
              <>
                <Divider />
                <Grid container alignItems="start" rowSpacing={2} my={2}>
                  {data.pubs.map(pub =>
                    <>
                      <Grid item xs={2}>
                        <Book color="primary" />
                      </Grid>
                      <Grid item xs={10}>
                        <Link href={pub.linc}>
                          {pub.collection}
                        </Link>
                      </Grid>
                    </>
                  )}
                </Grid>
              </>
            }

          </Box>
          <ImagePreview
            open={open}
            image={previewImage}
            handleClose={handleClose}
          />
        </CardContent>
      </Card>
    </Slide>
  )
}

export default CardComponent
